/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from './sectiondescription_styles';



/* ========== ~~~~~~~~~~ EXPANDABLE SECTION - SECTION DESC ~~~~~~~~~~ ========== */
const SectionDescription = (props) => {
  const {
    main,
    additional
  } = props
  return <div className={`sectiondescription ${props.classes.sectiondescription}`}>
    <h5>{main}</h5>
    <h6>{additional}</h6>
    {props.content}
  </div>
};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(SectionDescription);